import { STATUS_META, statusLabel, statusTone, toneClasses, FORWARD_STEPS, forwardIndexOf } from "@/lib/orderFlow";

export function StatusPill({ status, className = "" }) {
  return (
    <span className={`inline-block px-2 py-1 border font-mono text-[9px] uppercase tracking-[0.14em] ${toneClasses(statusTone(status))} ${className}`}>
      {statusLabel(status)}
    </span>
  );
}

// Compact horizontal stepper for the forward journey.
export function ForwardStepper({ status }) {
  const cur = forwardIndexOf(status);
  const off = ["cancelled", "rto_in_transit", "rto_delivered"].includes(status);
  return (
    <div className="flex items-center gap-0 overflow-x-auto py-1">
      {FORWARD_STEPS.map((s, i) => {
        const done = cur >= 0 && i <= cur && !off;
        const isCur = cur === i && !off;
        return (
          <div key={s.key} className="flex items-center shrink-0">
            <div className="flex flex-col items-center">
              <span className={`w-2.5 h-2.5 rounded-full ${done ? "bg-[hsl(var(--accent))]" : "bg-foreground/20"} ${isCur ? "ring-2 ring-[hsl(var(--accent))] ring-offset-1 ring-offset-background" : ""}`} />
              <span className={`mt-1 font-mono text-[8px] uppercase tracking-[0.1em] ${done ? "text-foreground" : "text-muted-foreground"}`}>{s.label}</span>
            </div>
            {i < FORWARD_STEPS.length - 1 && (
              <span className={`w-6 h-[1.5px] mx-0.5 mb-4 ${cur > i && !off ? "bg-[hsl(var(--accent))]" : "bg-foreground/20"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export function OrderTimeline({ timeline = [] }) {
  if (!timeline.length) return null;
  const items = [...timeline].reverse(); // newest first
  const fmt = (iso) => { try { return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };
  return (
    <ol className="relative border-l-[1.5px] border-foreground/20 ml-2 mt-2">
      {items.map((e, i) => (
        <li key={i} className="ml-4 pb-4 last:pb-0 relative">
          <span className={`absolute -left-[22px] top-1 w-2.5 h-2.5 rounded-full border-2 border-background ${i === 0 ? "bg-[hsl(var(--accent))]" : "bg-foreground/40"}`} />
          <p className="font-mono text-[10px] uppercase tracking-[0.12em]">{e.label || statusLabel(e.status)}</p>
          <p className="text-[11px] text-muted-foreground">
            {fmt(e.at)}{e.by_name ? ` · ${e.by_name}` : ""}{e.by_role && e.by_role !== "system" ? ` (${e.by_role})` : ""}
          </p>
          {e.note && <p className="text-[11px] mt-0.5 italic">"{e.note}"</p>}
        </li>
      ))}
    </ol>
  );
}
